import IconMi from 'components/common/icon/IconMi';
import { Box, IconButton } from '@mui/material';
import React from 'react';
import { DatasetInfo } from 'components/dataset-viewer/index';
import { HtmlTooltip } from 'components/html-tooltip';
import { useElementMetadataSettings } from 'hooks/useElementMetadata';
import { IElementData, IElementDataSettings } from 'components/common/element-data/types';
import ElementDataInfo from 'components/common/element-data/ElementDataInfo';
import { useAppSelector } from 'store/hooks';
import { UserAuth } from 'store/auth';
import isOwnerVisible from 'tools/owners';
import { TopicsInfo } from 'api/editor/topics';

export default function InfoIconButton({ datasetInfo }: { datasetInfo: DatasetInfo }) {
    const isCertified = datasetInfo.certified === 'Y';
    const { configuration }: UserAuth = useAppSelector((state) => state.auth);

    let metadataSettings = useElementMetadataSettings('info');
    const elementData: IElementData = {
        elementType: 'dataset',
        description: datasetInfo.description,
        descriptionMaxRows: 11,
        certifiedInd: datasetInfo.certified == 'Y',
        certificationLevelColor: 'success.main',
        lastCertifiedByName: datasetInfo.certified_by_dn,
        lastCertifiedTime: datasetInfo.certified_date,
        businessOwner: datasetInfo.business_owner_dn,
        //businessOwnerEmail: datasetInfo.business_owner_email,
        technicalOwner: datasetInfo.technical_owner_dn,
        //technicalOwnerEmail: datasetInfo.technical_owner_email,
        dataSteward: datasetInfo.data_steward_dn,
        //dataStewardEmail: datasetInfo.data_steward_email,
        categoryPath: datasetInfo.category_name,
        lastDisplayGenerationTime: datasetInfo.last_updated,
        customFields: datasetInfo.custom_fields,
        tagsNoAction: true,
        topics:
            datasetInfo.tags && datasetInfo.tags.length > 0
                ? ({
                      'default-topic-type': {
                          display_order: 0,
                          fa_icon: null,
                          icon: null,
                          icon_type: null,
                          topic_type_name: 'Tags',
                          topics: datasetInfo.tags.map((item: any) => {
                              return {
                                  topic_id: item.topic_type_id,
                                  name: item.name,
                              };
                          }) as any,
                          use_icon: '',
                      },
                  } as TopicsInfo)
                : undefined,
    };

    if (metadataSettings.fields['thumbnail']?.display) {
        metadataSettings.fields['thumbnail'].display = false;
    }

    ['business_owner', 'technical_owner', 'data_steward'].forEach((ownerField) => {
        if (metadataSettings.fields[ownerField]?.display) {
            metadataSettings.fields[ownerField].display = isOwnerVisible(
                (configuration.owners as any)[ownerField],
                'datasets',
            );
        }
    });

    const elementDataSettings: IElementDataSettings = {
        metadata: metadataSettings,
    };

    return (
        <HtmlTooltip
            placement={'bottom'}
            arrow={false}
            certified={isCertified}
            title={
                <Box>
                    <ElementDataInfo
                        elementData={elementData}
                        elementDataSettings={elementDataSettings}
                        showHeader={elementDataSettings.metadata.settings.showSectionHeaders}
                    />
                </Box>
            }
            slotProps={{
                tooltip: {
                    sx: {
                        maxHeight: 'calc(100vh - 100px)',
                        overflow: 'auto',
                    },
                },
                popper: {
                    sx: {},
                },
            }}
        >
            <IconButton sx={{ p: '6px' }}>
                {isCertified ? (
                    <Box
                        sx={{
                            display: 'flex',
                            color: 'success.main',
                            fontSize: '16px',
                        }}
                    >
                        <IconMi icon={'certified'} />
                    </Box>
                ) : (
                    <IconMi icon={'info-circle'} fontSize="16" />
                )}
            </IconButton>
        </HtmlTooltip>
    );
}
